import { Link } from "react-router-dom";

const Completion = ({
  title,
  explanation,
  link,
  btntext,
  isLoggedIn = true,
}) => {
  const returnMainContent = () => {
    return (
      <>
        <h1 className="p-heading01">{title}</h1>
        <p>{explanation}</p>
        <div className="p-login-form__btnbox">
          {link.indexOf("/mypage/") === -1 ? (
            <a href={link}>
              <input
                className="p-login-form__link"
                type="button"
                value={btntext}
              />
            </a>
          ) : (
            <Link to={link}>
              <input
                className="p-login-form__link"
                type="button"
                value={btntext}
              />
            </Link>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {isLoggedIn ? (
        <div className="l-page-right">
          <div className="l-page-con">{returnMainContent()}</div>
        </div>
      ) : (
        <main className="l-main">
          <div className="container">
            <div className="col-lg-10 offset-lg-1">
              <div className="p-login-con">{returnMainContent()}</div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default Completion;
